// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".register-button[data-v-d8422c48]{box-shadow:1px 1px 18px #e4a}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
